module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-lazyload-26.fdde6ef1.jpg";